import { render } from "./CircleTest.vue?vue&type=template&id=00a77839"
import script from "./CircleTest.vue?vue&type=script&lang=js"
export * from "./CircleTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__